import styled from 'styled-components';
import { color } from '../../resources';

export const SplashContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${color.overlay};
  align-items: center;
  justify-content: center;
  display: flex;
`;
